import { LOCALES } from 'i18n/locales';

export const legendIntl = {
    [LOCALES.ENGLISH]: {
        'legend.noAssets': 'No assets are currently visible on the map.'
    },
    [LOCALES.WELSH]: {
        'legend.noAssets': 'Dim asedau yn weladwy ar hyn o bryd ar y map.'
    }
};
